import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: `${theme.spacing(4)} !important`,
    alignSelf: 'stretch',
    maxWidth: theme.spacing(57.4375),
  },

  field: {
    width: '100%',
  },
  content: {
    display: 'flex',
    gap: `${theme.spacing(5)} !important`,
    flexDirection: 'row',
  },
  boldText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2.5),
    width: '100%',
  },
  fieldTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    minWidth: theme.spacing(57.4375),
  },
  subText: {
    fontSize: '12px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px !important',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
  },
  urlBoldText: {
    fontSize: '12px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px !important',
    color: theme.palette.select.light,
    fontFamily: theme.typography.fontFamily,
  },
  disabled: {
    '& .MuiInputBase-input': {
      '-webkit-text-fill-color': `${theme.palette.labraText.primary} !important`,
    },
  },
}))
